module.exports = __webpack_public_path__ + "img/Entity.f6bc49a7.svg";